<rms-mod [flippable]="true" transitionMode="morph"
         [flipped]="!!SelectedProduct || !!ViewGrouping"
         collapsedWidth="25%"
         expandedWidth="98%"
         height="85vh"
         [includeHeader]="true"
         [backButton]="!!SelectedProduct && !NewProduct || !!ViewGrouping"
         (backButtonClicked)="handleBackClick()">
  <div mod-front style="height:85vh">
    <rms-table [data]="CoffeeProducts"
               [columns]="ProductsColumns"
               [clickableRow]="true"
               (onRowClick)="SelectProduct($event)"
               [HeaderButtons]="HeaderButtons">
    </rms-table>
  </div>
  <div mod-back style="height:85vh">
    <div style="width:100%">
      @if(SelectedProduct || NewProduct){
      <app-coffee-data (NewSkuExists)="onSkuExists($event)" (SkuCreated)="onNewProductCreated($event)" (SkuCancelled)="onSkuCancelled()" (BackToList)="BackToList()" [Product]="SelectedProduct"></app-coffee-data>
      }
      @if(ViewGrouping){
      <app-coffee-grouping></app-coffee-grouping>
      }
    </div>
  </div>
</rms-mod>
